import React from "react";
import {IconRobot} from "@tabler/icons-react";
import {MiniCard} from "./MiniCard";
import {useDashboard} from "../../../../context/DashboardContext";

export const ChatbotCard = () => {
  const {responseTime} = useDashboard();

  const avgChatbot = (
    responseTime?.filter(i => +i?.avgChatbot > 0)
      ?.map(i => +i?.avgChatbot)
      ?.reduce((prev, next) => prev + next, 0) /
    responseTime?.filter(i => +i?.avgChatbot > 0)?.length
  )?.toFixed(2) || 0;

  const chartData = responseTime?.map(i => ({
    ...i,
    dateCreated: i?.hour,
    duration: i?.avgChatbot?.toFixed(2)
  }));

  return (
    <MiniCard
      icon={IconRobot}
      color={"#1979a3"}
      title={`${avgChatbot}s`}
      subtitle={"CHATBOT"}
      data={chartData}
    />
  );
};
